export class SearchParamsModel {
    locCode: string;
    locCodeValue: string;
    selectedPeriodRange: string;
    locationType: number;
    periodStartDate: string;
    periodEndDate: string;
    trucker: string;
    customer: string;
    origin: string;
    destination: string;
    commodity: string;
    //shipThroughDate: string;
    locationId: string;
    selectedSearchFor: string;
    truckerName?: string;
    customerName?: string;
    originName?: string;
    destinationName?: string;

}